export const alaska = {
  "02000": "Alaska",
  "02013": "Aleutians East Borough",
  "02016": "Aleutians West Census Area",
  "02020": "Anchorage Borough",
  "02050": "Bethel Census Area",
  "02060": "Bristol Bay Borough",
  "02068": "Denali Borough",
  "02070": "Dillingham Census Area",
  "02090": "Fairbanks North Star Borough",
  "02100": "Haines Borough",
  "02110": "Juneau Borough",
  "02122": "Kenai Peninsula Borough",
  "02130": "Ketchikan Gateway Borough",
  "02150": "Kodiak Island Borough",
  "02164": "Lake and Peninsula Borough",
  "02170": "Matanuska-Susitna Borough",
  "02180": "Nome Census Area",
  "02185": "North Slope Borough",
  "02188": "Northwest Arctic Borough",
  "02201": "Prince of Wales-Outer Ketchikan Census Area",
  "02220": "Sitka Borough",
  "02231": "Skagway-Yakutat-Angoon Census Area",
  "02232": "Skagway-Hoonah-Angoon Census Area",
  "02240": "Southeast Fairbanks Census Area",
  "02261": "Valdez-Cordova Census Area",
  "02270": "Wade Hampton Census Area",
  "02280": "Wrangell-Petersburg Census Area",
  "02282": "Yakutat Borough",
  "02290": "Yukon-Koyukuk Census Area",
};
